import { DataAttributeDefinitions } from 'scrivito'

import { pisaOrderDataClass } from './Pisa/pisaOrderDataClass'

const attributes: DataAttributeDefinitions = {}

export const Order = pisaOrderDataClass(attributes)
